export default __webpack_public_path__ + "static/media/logo1.21b8ffb4.png";